import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { EnteEsecutore } from '../models/ente.model';
import { RichiestaSupportoDTO } from '../models/requests/richiesta-supporto.model';

@Injectable({
  providedIn: 'root'
})
export class EntiEsecutoriService {
  private apiUrl = environment.apiUrl + "ente-esecutore"; // URL base per le API delle richieste

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) { }

    get(): Observable<EnteEsecutore[]> {
      return this.http.get<EnteEsecutore[]>(`${this.apiUrl}`);
    }

    getById(id: number): Observable<EnteEsecutore> {
      return this.http.get<EnteEsecutore>(`${this.apiUrl}/${id}`);
    }

    getStatsConsorzi(): Observable<EnteEsecutore[]> {
      return this.http.get<EnteEsecutore[]>(`${this.apiUrl}/consorzi-con-stato`);
    }
    getStatsConsorziPerAnno(anno: number): Observable<EnteEsecutore[]> {
      return this.http.get<EnteEsecutore[]>(`${this.apiUrl}/consorzi-con-stato?anno=${anno}`);
    }

    getStatsUMVS(): Observable<EnteEsecutore> {
      return this.http.get<EnteEsecutore>(`${this.apiUrl}/umvs-con-stato`);
    }
    getStatsUMVSPerAnno(anno: number): Observable<EnteEsecutore> {
      return this.http.get<EnteEsecutore>(`${this.apiUrl}/umvs-con-stato?anno=${anno}`);
    }
    richiestaSupporto(richiestaSupporto: RichiestaSupportoDTO): Observable<any> {
      return this.http.post<any>(`${this.apiUrl}/${richiestaSupporto.enteEsecutoreId}/richiesta-supporto`, richiestaSupporto);
    }

}
